// extracted by mini-css-extract-plugin
export default {"background":"FormLayout_background__TXvWs","wrapper":"FormLayout_wrapper__75Cjd"};